import type { ReactNode } from 'react'

interface PlaceholderSectionProps {
  title: string
  /** Overrides the default "Details to follow." placeholder with section-specific copy. */
  children?: ReactNode
}

/** Titled panel for a page section whose real content hasn't been designed yet. */
export function PlaceholderSection({ title, children }: PlaceholderSectionProps) {
  return (
    <section className="mt-8">
      <h2 className="text-ink mb-3 text-xl font-bold tracking-tight">{title}</h2>
      <div className="border-ink-100 rounded-xl border p-6">
        {children ?? <p className="text-ink-400 text-sm">Details to follow.</p>}
      </div>
    </section>
  )
}
